var map = {
	"./Approach.jpg": 588,
	"./DoubleSlit.png": 356,
	"./DoubleSlit2.png": 373,
	"./doubleSlit2.jpg": 273,
	"./efe-kurnaz-RnCPiXixooY-unsplash.jpg": 242,
	"./nixie-3407305_1280.jpg": 772,
	"./tj-holowaychuk-1EYMue_AwDw-unsplash.jpg": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;